import { useEffect, useState } from 'react'

interface iVideoBlob {
  src: string | undefined
  progresso: number | null
}

// o storage não aceita pulo em arquivo remoto, então baixa inteiro e toca o blob local
export function useVideoBlob(url: string, ativo: boolean): iVideoBlob {
  const [resultado, setResultado] = useState<{ url: string, src: string } | null>(null)
  const [progresso, setProgresso] = useState<number | null>(null)

  useEffect(() => {
    if (!ativo || !url) return

    const controller = new AbortController()
    let objectUrl: string | undefined
    setProgresso(null)

    async function baixar(): Promise<void> {
      try {
        const resposta = await fetch(url, { signal: controller.signal })
        if (!resposta.ok || resposta.body === null) throw new Error('Falha ao baixar o vídeo')

        const total = Number(resposta.headers.get('Content-Length'))
        const leitor = resposta.body.getReader()
        const partes: BlobPart[] = []
        let recebido = 0

        for (;;) {
          const { done, value } = await leitor.read()
          if (done) break
          partes.push(value)
          recebido += value.length
          if (total > 0) setProgresso(Math.round((recebido / total) * 100))
        }

        objectUrl = URL.createObjectURL(new Blob(partes, { type: 'video/mp4' }))
        setResultado({ url, src: objectUrl })
      } catch {
        if (!controller.signal.aborted) setResultado({ url, src: url })
      }
    }

    void baixar()

    return () => {
      controller.abort()
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [url, ativo])

  return { src: resultado?.url === url ? resultado.src : undefined, progresso }
}
